export default __webpack_public_path__ + "static/media/trampapo_02_13.44963e7a.jpg";